import * as React from 'react';

interface SvgImageProps {
  title?: string;
  reference: string;
  ariaHidden?: boolean;
  className?: string;
}

const SvgImage = ({
  title,
  reference,
  ariaHidden,
  className,
}: SvgImageProps) => (
  <svg className={className} aria-hidden={ariaHidden}>
    {title && (
      <title>{title}</title>
    )}
    <use xlinkHref={reference} />
  </svg>
);

export default SvgImage;
